
export enum LocationHierarchyTypeCd {
	DISTRICT = 'District',
	REGION = 'Region',
	SIC = 'Sic'}

